import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "prospectivly_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) {
        // Defer to avoid layout shift on first paint
        const t = setTimeout(() => setVisible(true), 600);
        return () => clearTimeout(t);
      }
    } catch (_) {
      setVisible(true);
    }
  }, []);

  const persist = (value) => {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch (_) {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie preferences"
      data-testid="cookie-banner"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[60] w-[calc(100%-2rem)] max-w-3xl rounded-2xl border border-[#2A2E3D] bg-[#151821]/95 backdrop-blur-xl shadow-[0_20px_60px_-20px_rgba(0,0,0,0.6)] p-5 sm:p-6"
    >
      <div className="flex items-start gap-4">
        <div className="hidden sm:flex items-center justify-center w-10 h-10 rounded-full bg-[#FF4500]/15 text-[#FF4500] flex-shrink-0">
          <Cookie className="w-5 h-5" />
        </div>
        <div className="flex-1">
          <p className="font-editorial text-xl text-[#EDEDED] tracking-tight mb-1">
            We use a few cookies.
          </p>
          <p className="text-sm text-[#9CA3AF] leading-relaxed">
            Prospectivly uses essential cookies to make the site work and a
            small set of analytics events to understand how it's used. Read more
            in our{" "}
            <Link
              to="/privacy"
              className="text-[#FF4500] underline hover:text-[#E03C00]"
            >
              Privacy Policy
            </Link>
            .
          </p>
          <div className="mt-4 flex flex-wrap gap-3">
            <button
              type="button"
              data-testid="cookie-accept-button"
              onClick={() => persist("accepted")}
              className="inline-flex items-center justify-center bg-[#FF4500] hover:bg-[#E03C00] text-white px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300 hover:shadow-[0_0_24px_rgba(255,69,0,0.35)]"
            >
              Accept all
            </button>
            <button
              type="button"
              data-testid="cookie-essential-button"
              onClick={() => persist("essential-only")}
              className="inline-flex items-center justify-center bg-transparent border border-[#2A2E3D] hover:border-[#EDEDED] text-[#EDEDED] px-5 py-2.5 rounded-full text-sm font-medium transition-all"
            >
              Essential only
            </button>
          </div>
        </div>
        <button
          type="button"
          aria-label="Dismiss cookie banner"
          data-testid="cookie-dismiss-button"
          onClick={() => persist("dismissed")}
          className="p-2 -m-2 text-[#9CA3AF] hover:text-[#EDEDED] transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
